import React, {useEffect, useState} from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Tooltip,
    IconButton,
    Typography, Button, Fab,
} from "@mui/material";
import {Bike, Headset, MessagesSquare, Store, UserRound} from "lucide-react";
import {useTranslation} from "react-i18next";
import ChatButton from "./ChatButton";
import axios from "axios";
import {defaultVariables} from "../../../config";
import Badge from "@mui/material/Badge";
import Courier from "../../components/icons/Courier";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";

const ChatFAB = ({order,role,user,}) => {
    const { t } = useTranslation();

    const [fabOpen, setFabOpen] = useState(false);
    const [count, setCount] = useState([]);
    const loginToken = localStorage.getItem("ACT");
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`,
        }
    }
    const loadData = () =>{
        axios.get(`${defaultVariables.url}/messages/count-unread/${order.id}`,config)
            .then(response => {
                setCount(response.data);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
            });
    }
    useEffect(() => {
        loadData();
    },[]);

    return (
        <>
            {
                (order.status !== "canceled" && order.status !== "finished" && order.status !== "not_paid") &&
                <>
                    {
                        !!fabOpen &&
                        <div className="chat-holder">
                            {
                                (role === "user" || role === "supplier" || role === "transport") &&
                                <Badge badgeContent={count['support']} color="secondary">
                                <ChatButton
                                    reload={() => loadData()}
                                    sender={user}
                                    receiver={order.support}
                                    order={order}
                                    icon={<Headset className="lucide-small-narrow"/>}
                                    title={t('sendMessageToSupport')}
                                    className="chat-btn"
                                    color="text"
                                    variant="outlined"
                                />
                                </Badge>
                            }
                            {(role === "admin" || role === "transport" || role === "user") &&
                                <Badge badgeContent={count['supplier']} color="secondary">
                                    <ChatButton
                                        reload={() => loadData()}
                                        sender={user}
                                        receiver={order.shop?.owner}
                                        order={order}
                                        icon={<Store className="lucide-small-narrow"/>}
                                        title={t('sendMessageToShopOwner')}
                                        className="chat-btn"
                                        color="text"
                                        variant="outlined"
                                    />
                                </Badge>
                            }
                            {
                                (role === "admin" || role === "supplier" || role === "transport") &&
                                <Badge badgeContent={count['customer']} color="secondary">
                                    <ChatButton
                                        reload={() => loadData()}
                                        sender={user}
                                        receiver={order.user}
                                        order={order}
                                        icon={<UserRound className="lucide-small-narrow"/>}
                                        title={t('sendMessageToCustomer')}
                                        className="chat-btn"
                                        color="text"
                                        variant="outlined"
                                    />
                                </Badge>
                            }
                            {
                                ((role === "admin" || role === "supplier" || role === "user") && !!order.courier) &&
                                <Badge badgeContent={count['courier']} color="secondary">
                                    <ChatButton
                                        reload={() => loadData()}
                                        sender={user}
                                        receiver={order.courier}
                                        order={order}
                                        icon={<Bike className="lucide-small-narrow" />}
                                        title={t('sendMessageToCourier')}
                                        className="chat-btn"
                                        color="text"
                                        variant="outlined"
                                    />
                                </Badge>
                            }
                        </div>
                    }
                    <div className="chat-fab">
                        <Badge badgeContent={count['total']} color="secondary">
                            <Fab
                                size="large"
                                color="primary"
                                aria-label="add"
                                onClick={() => setFabOpen(!fabOpen)}
                            >
                                <MessagesSquare className="lucide-xl"/>
                            </Fab>
                        </Badge>
                    </div>
                </>
            }
        </>
    );
};
const mapStateToProps = (state) => ({
    user: state.user,
});

export default withStyles(Styles)(connect(mapStateToProps)(ChatFAB));
